import {Helmet} from "react-helmet-async";

const BASE_URL = "https://aprietaygana.com";
const DEFAULT_TITLE = "Aprieta y Gana - Hoy te puede tocar a ti - Tu plataforma de apuestas en línea";
const DEFAULT_DESCRIPTION =
  "Aprieta y Gana - Tu plataforma de apuestas en línea. Hoy te puede tocar a ti. Juega, apuesta y gana con nosotros.";
const DEFAULT_IMAGE = `${BASE_URL}/ayg-social-preview.jpg`;

const SEO = ({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  path = "/",
  image = DEFAULT_IMAGE,
  noIndex = false,
}) => {
  const canonicalUrl = `${BASE_URL}${path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta
        name="title"
        content={title}
      />
      <meta
        name="description"
        content={description}
      />
      <link
        rel="canonical"
        href={canonicalUrl}
      />
      {noIndex && (
        <meta
          name="robots"
          content="noindex, nofollow"
        />
      )}

      {/* Open Graph / Facebook */}
      <meta
        property="og:type"
        content="website"
      />
      <meta
        property="og:url"
        content={canonicalUrl}
      />
      <meta
        property="og:title"
        content={title}
      />
      <meta
        property="og:description"
        content={description}
      />
      <meta
        property="og:site_name"
        content="Aprieta y Gana"
      />
      <meta
        property="og:image"
        content={image}
      />

      {/* Twitter */}
      <meta
        property="twitter:card"
        content="summary_large_image"
      />
      <meta
        property="twitter:url"
        content={canonicalUrl}
      />
      <meta
        property="twitter:title"
        content={title}
      />
      <meta
        property="twitter:description"
        content={description}
      />
      <meta
        property="twitter:image"
        content={image}
      />
    </Helmet>
  );
};

export default SEO;
